



































































































































































/* eslint-disable */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { ValidationObserver } from 'vee-validate';
import Select2 from '@/components/Select2.vue';
import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import FileIcon from 'mdi-vue/File';
import DownloadIcon from 'mdi-vue/Download';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import VueMonthlyPicker from 'vue-monthly-picker';
import { ModelListSelect, ModelSelect } from 'vue-search-select';

import { User, Division, Service } from '@/libs/api.interfaces';

import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import CalendarIcon from '@/assets/calendar.svg';
import ReconmerchantTable from './ReconListTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    SearchIcon,
    FileIcon,
    DownloadIcon,
    SearchRow,
    SearchField,
    Select,
    ReconmerchantTable,
    Modal,
    FormInput,
    ValidationObserver,
    Select2,
    VueMonthlyPicker,
    ModelListSelect,
    ModelSelect,
    CalendarIcon,
  },
})
export default class ReconmerchantList extends Vue {
  $refs!: {
    table: ReconmerchantTable;
  }
  loadingExport = false;

  merchantLoginData: any = this.$store.state.user.user.merchant;

  dialogReason = false;
  codestatus: any = '';
  startperiode = '';
  endperiode = '';
  selectedPaymentChannel = '';
  selectedMerchant = '';


  loadingService = false;
  selectedService: Service | null = null;
  selectedServiceGenerate: Service | null = null;

  listPaymentChannel: any = [];
  listMerchant: any = [];
  locale = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  reconStatus = [
    { value: "", label: 'All Status' },
    { value: 0, label: 'Waiting Merchant Confirmation' },
    { value: 1, label: 'Waiting Bayarind Feedback' },
    { value: 2, label: 'Confirmed' },
    // { value: 3, label: 'Genereted' },
    { value: 4, label: 'Waiting Bayarind Approval' },
    { value: 5, label: 'Active Period' },
  ];
  selectedReason: string = '';
  listReason: any[] = [
    'Tidak ada konfirmasi dari merchant sehingga traffic mengikuti dari Bayarind',
    'Merchant request agar diterbitkan saja invoicenya',
  ];

  async getPaymentChannel() {
    const { data } = await api.get('/recon/services');
    this.listPaymentChannel = data.data;
    if (Array.isArray(this.listPaymentChannel)) {
      this.listPaymentChannel.unshift({
        service: "",
        service_name: "All Payment Channel",
      });
    }
  }

  async getMerchantList() {
    const { data } = await api.get('/recon/merchant');
    this.listMerchant = data.data;
    if (Array.isArray(this.listMerchant)) {
      this.listMerchant.unshift({
        merchant_code: "",
        merchant_name: "All Merchant",
      });
    }
  }

  async mounted() {
    this.startperiode = dayjs().add(-3, 'month').toString();
    this.endperiode = dayjs().toString();
    this.getMerchantList();
    this.getPaymentChannel();
    this.getListData(1);
  }

  async getListData(page: number, isExport: boolean = false) {
    /* eslint-disable @typescript-eslint/camelcase */
    if (page === 1 && this.$route.query.page) {
      let query = Object.assign({}, this.$route.query);
      delete query['page'];
      this.$router.replace({ query });
    }
    const params = {
      start_periode: dayjs(this.startperiode.toString()).format('YYYY-MM'),
      end_periode: dayjs(this.endperiode.toString()).format('YYYY-MM'),
      service: this.selectedPaymentChannel,
      status: this.codestatus,
      merchant_code: this.merchantLoginData ? this.merchantLoginData.merchant_code : this.selectedMerchant,
      limit: '10',
    };
    await this.$refs.table.getListData(params, page, isExport);
  }

  clearFilter() {
    this.startperiode = '';
    this.endperiode = '';
    this.selectedPaymentChannel = '';
    this.codestatus = '';
    this.selectedMerchant = '';
  }

  disableConfirmAll() {
    try {
      if (this.$refs.table) {
        let listSelected: string[] = Object.keys(this.$refs.table.selected) || [];
        if (listSelected.length) {
          for (const value of Object.values(this.$refs.table.selected)) {
            if (value.status !== 0) {
              return true;
            }
          }
        } else {
          return true;
        }
        return false;
      } else { return true; }
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  confirmAll() {
    try {
      this.dialogReason = false;
      let finalData: any[] = Object.keys(this.$refs.table.selected);

      api.post('recon/traffic/confirm/batch',
        {
          reason: this.selectedReason,
          data: JSON.stringify(finalData),
        }).then((result: any) => {
          if (result.data.status) {
            showToast(ToastType.SUCCESS, 'Confirm All Traffic Success', 'Merchant billing has been successfully confirmed');
            this.getListData(this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1);
            this.$refs.table.selected = {};
          } else {
            showToast(ToastType.FAILED, 'Confirm All Traffic Failed', result.data.message);
          }
        }).catch((error: any) => {
          console.log(error)
          showToast(ToastType.FAILED, 'Confirm All Traffic Failed', 'An Error Occured');
        })
    } catch (error) {
      console.log(error);
    }
  }

  async exportData() {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');
    this.loadingExport = true;
    await this.getListData(this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1, true);
    this.loadingExport = false;
  }

  @Watch('$route')
  onRouteChange() {
    this.getListData(parseInt(this.$route.query.page.toString()));
  }
}
